<template>
  <div class="video-info">
    <div class="content-wrapper">
      <div class="video-info-inner">
        <span v-html="'Wiadomość od Jurka Owsiaka'"></span>
        <a @click.prevent="setActiveVideoPopup('68s4YxzprOQ')" href="#">Zobacz</a>
        <Portal
          v-if="activeVideoPopup == '68s4YxzprOQ'"
          to="video-player"
      >
          <transition name="slide-fade">
              <video-player
                  :youtube_id="'68s4YxzprOQ'"
                  :closed="false"
                  v-on:closePlayer="receiverClosePopup()"
              ></video-player>
          </transition>
      </Portal>
      </div>
    </div>
  </div>
</template>

<script>
  import videoPlayer from "@/components/video-player";

  export default {
    data() {
      return {
        activeVideoPopup: null
      };
    },
    methods: {
        setActiveVideoPopup: function(youtube_id) {
            // ga(
            //     "send",
            //     "event",
            //     "top banner",
            //     "banner click",
            //     "wiadomosc od jurka"
            // );
            this.activeVideoPopup = youtube_id;
        },
        receiverClosePopup: function() {
            this.activeVideoPopup = null;
        }
    },
    components: {
      videoPlayer
    }
  };
</script>

<style lang="scss" scoped>
  @import "@/scss/_general.scss";

  .video-info {
    padding-top: 20px;

    .content-wrapper {
      
      .video-info-inner {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 22px;
        background: #fff;
        font-weight: 600;
        padding: 15px 24px;
        line-height: 30px;

        @media only screen and (max-width: 1200px) {
          flex-direction: column;
          text-align: center;
        }

        span {
            display: inline;
        }

        a {
          font-size: 14px;
          color: #000;
          text-decoration: none;
          font-weight: 600;

          &:hover {
            text-decoration: underline;
          }

          @media only screen and (max-width: 1200px) {
            margin-top: 10px;
          }
        }
      }
    }
  }
</style>